// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__fvqaJ","p":"Footer_p__O7o+U","git":"Footer_git__Blmf2","linked":"Footer_linked__K0ims","copy":"Footer_copy__7FwAJ"};